module.exports = __webpack_public_path__ + "static/regulamin-bdd84be76ac93e3fee99c207f1a6b8af.pdf";